export default "__VITE_ASSET__Bttui3S3__"